import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addCartItem, cartItemDecreament } from '../Redux/Cart-system'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router'
import { addToCart, addWishlist, customizeBooking } from '../Services/Operations/ProductAPI'
import {  baseURL } from '../Services/api_endpoints'
import Cookies from "js-cookie";


// const baseURL=baseURL|| "http://192.168.29.250:9998/api"

const ProductCard = ({name,description,img,price,rate,id,stock,type,totalAmount,grandTotal}) => {

    const dispatch=useDispatch()
    const navigate=useNavigate()
    const [mobile,setMobile]=useState(window.innerWidth<567)
    const [bookingModal,setBookingModal]=useState(false)
    const[pickupLocation,setPickupLocation]=useState("")

    const carts=useSelector((state)=>state.cart.cartItems)

    const handleAddToCart = async()=>{
      
      
      if(!Cookies.get('loginData')){
        navigate('/login')
        toast.error("Unauthorized,Login first")
        return
      }

        try {
            const exists=carts.find(item => item.id === id);
            if(exists){
               toast.error("Item already exists in the cart")
               return;
            }
            if(stock<1){
              toast.info("Product stock is empty")
               return;
            }
            
            dispatch(addCartItem({name,id,price,rate:rate,quantity:1,img,stock}))

             const response=await addToCart({"productId":id, "quantity": 1,"price":price})
             if(response.status!==200){
              dispatch(cartItemDecreament({id:id}))
             return toast.error("Failed to addd cart in server")

             }else{
              toast.success("Item added to cart successfully")
             }
            
        } catch (error) {
           console.log("failed to add cart",error);
           
        }finally{
             console.log("carts : ",carts);
        }
        

       
        
        
    }

    const handleBooking=async()=>{
      console.log('product booking...');
      let data={
        productId:id,
        quantity:1,
        price:price,
        totalAmount:price*1,
        grandTotal:price*1,
        pickupLocation
      }

      try {
        const response=await customizeBooking(data)
        if(response.status===201){
          toast.success("Booking request submitted successfully")
        }
        console.log(response);
        
      } catch (error) {
        console.log(error);
        toast.error("Failed to submit booking request")
        
      }
      

    }
    const handleAddWishlist=async(id)=>{
      try {
        const response=await addWishlist({productId:id})
        console.log(response);
        if(response.status===200){
          toast.success("Product added to wishlist!")
        }
        
      } catch (error) {
        console.log(error);
        
      }
    }

 function findCart(id){
          const exists=carts.find(item => item.id === id);
           return exists
      }

    useEffect(() => {
     findCart(id)
      
    }, [carts])
    
  return (
   
        <div className="col-md-6 col-lg-4 col-xl-3"
        style={{height:mobile?"40vh":"55vh",borderRadius:"10px",width:mobile?"45vw":"21vw",
          transition: "transform 0.3s ease-in-out"}}
            onMouseEnter={e => (e.currentTarget.style.transform = "scale(1.05)")}
           onMouseLeave={e => (e.currentTarget.style.transform = "scale(1)")}
        >
                        <div className="rounded position-relative fruite-item" style={{height:"100%",borderRadius:"10px",borderLeft:"0.5px solid #eedf15ff",borderRight:"0.5px solid #eedf15ff", borderBottom:"0.5px solid #eedf15ff"}}>
                          <div className=" "  style={{width:"100%",height:"65%",overflow:"hidden"}}
                          onClick={() => navigate(`/shop-details/${id}`)}
                            
                          >
                            <img
                              src={`${baseURL+img}`}
                              className="img-fluid w-100 rounded-top product-img"
                              alt
                              style={{objectFit:"fill",width:"100%",height:"100%"}}
                            />
                          </div>
                          <div
                            className="text-white bg-secondary px-3 py-1 rounded position-absolute"
                            style={{ top: 10, left: 10 ,cursor:"pointer"}}
                            onClick={() =>handleAddWishlist(id)}
                          >
                             <img src='Assets/img/love.png'
                              style={{width:20}}
                              />
                          </div>

                         <div
                            className="text-white px-3 py-1 rounded position-absolute"
                            style={{ top: 10, right: 10 }}
                          
                          >
                            <div style={{position:"relative"}}>
                              <img src='Assets/img/in-stock.png'
                              style={{width:40}}
                              />
                              <p className='bg-primary  '
                              style={{position:"absolute",zIndex:999,top:1,right:1,fontSize:"10px",padding:"6px",borderRadius:"100%"}}
                              >{stock}</p>
                            </div>
                            
                          </div>

                          <div className="p-2 rounded" style={{height:"35%"}} >
                           
                            {/* <p style={{}}>
                            {description.length > 48 ? description.slice(0, 48) + "..." : description}
                            </p> */}
                            <div className="d-flex  justify-content-between flex-lg-wrap align-items-center" style={{flexDirection:"column"}}>
                                  <p className='text-dark fw-bold'
                                  style={{fontSize:mobile?"15px":"20px"}} 
                                   onClick={() => navigate(`/shop-details/${id}`)}>
                                    {name.length > 18 ? name.slice(0, 18) + "..." : name}</p>
                              <div style={{display:'flex',alignItems:"center",gap:"20px"}}>
                                

                               <p className="text-dark fs-7 fw-bold mb-0"
                              style={{fontSize:mobile?"10px":"13px"}}
                              >
                               ₹{price}
                              </p></div>
                              {/* <p>{rate}</p> */}
                              {!findCart(id)?
                              <div
                                onClick={()=>type===1?handleAddToCart():setBookingModal(true)}
                                href="#"
                                className="btn border border-secondary rounded-pill px-3 text-primary"
                                style={{fontSize:mobile?"10px":"14px"}}
                              >
                              {!mobile&&  <i className="fa fa-shopping-bag me-2 text-primary" />}
                                {" "}
                              {stock<=0?"Unavailable":type===1?  "Add to Cart":"Book Now"}
                               
                              </div>:
                              <div
                                onClick={()=>navigate('/cart')}
                                href="#"
                                className="btn border border-secondary rounded-pill px-3 text-primary"
                                style={{fontSize:mobile?"10px":"14px"}}
                              >
                                {!mobile&&  <i className="fa fa-shopping-bag me-2 text-primary" />}{" "}
                               Go To Cart
                              </div>}
                            </div>
                          </div>
                        </div>


      {
        bookingModal && 
        <div style={{position:"fixed",zIndex:999,top:"200px",left:"20px",width:"200px",height:"200px",backgroundColor:"white",borderRadius:"10px",border:"1px solid grey",display:"flex",flexDirection:"column",alignItems:"center",gap:"20px"}}>
          <p>enter location</p>
          <p onClick={()=>setBookingModal(false)}
          style={{cursor:"pointer",position:"absolute",top:"10px",right:"10px"}}>X</p>
          <textarea
          value={pickupLocation}
          onChange={(e)=>setPickupLocation(e.target.value)}
          style={{border:"0.3px solid gray",outline:"none"}}
          >
            </textarea>

          <p onClick={handleBooking}
          style={{padding:"10px",backgroundColor:"#1b76ffff",color:"white",width:"fit-content",borderRadius:"8px",cursor:"pointer"}}>Submit</p>

        </div>
      }
                      </div> 
   
  )
}

export default ProductCard